import { CmsReactComponent } from 'components/cms/CmsReactComponent';
import { EntryOptions, PropertyDefinition, PropertyMappingType, } from "app/library/layout-builder";
import { MobileInstrumentsCategoriesProps } from "./types";
import { MetaTypeEnum } from "app/shared";

export class MobileInstrumentsCategoriesDefinitions extends CmsReactComponent<MobileInstrumentsCategoriesProps> {
    static defaultProps = {};

    static schemaName = "mobile-instruments-categories";

    static propertyDefinitions: PropertyDefinition[] = [
        {
            name: "title",
            mapping: {
                type: PropertyMappingType.String,
            },
            default: "",
            text: "Başlık",
        },
        {
            name: "secondTitle",
            mapping: {
                type: PropertyMappingType.String,
            },
            default: "",
            text: "Alt Başlık",
        },
        {
            name: "backAnchor",
            mapping: {
                type: PropertyMappingType.LinkWizard,
            },
            default: "",
            text: "Geriye Dönmek İçin Kullanılan Anchor",
        },
        {
            name: "data",
            mapping: {
                type: PropertyMappingType.ArrayData,
                keys: [
                    {
                        name: "turkishInformationTitle",
                        mapping: {
                            type: PropertyMappingType.String,
                        },
                        default: "",
                        text: "Türkçe Bilgi Başlığı",
                    },
                    {
                        name: "englishInformationTitle",
                        mapping: {
                            type: PropertyMappingType.String,
                        },
                        default: "",
                        text: "İngilizce Bilgi Başlık",
                    },
                    {
                        name: "anchor",
                        mapping: {
                            type: PropertyMappingType.LinkWizard,
                        },
                        description: "Liste Url ",
                        default: null,
                    }
                ]
            },
            group: {
                key: "data",
                title: "Kart Verileri",
                withObject: false,
            },
            default: "",
            text: "List"
        },
    ];

    static options: EntryOptions = {
        meta: {
            use: true,
            allowedTypes: [
                MetaTypeEnum.Text,
                MetaTypeEnum.TextArea,
                MetaTypeEnum.SingleImage,
                MetaTypeEnum.Editor,
                MetaTypeEnum.Link
            ],
        },
        mappingFields: [
            {
                name: "title",
                text: "Başlık",
                types: [MetaTypeEnum.Text, MetaTypeEnum.TextArea],
            },
            {
                name: "secondTitle",
                text: "İkincil Başlık",
                types: [MetaTypeEnum.Text, MetaTypeEnum.TextArea],
            },
            {
                name: "anchor",
                text: "URL",
                types: [MetaTypeEnum.Link]
            },
        ],
    };
}
